<template>
  <div class="xl:w-full xl:h-full flex xl:flex-nowrap flex-wrap">
    <div
      class="xl:w-2/3 sm:items-start items-center sm:text-left text-center w-full xl:h-full xl:pt-14 pt-6 xl:px-14 lg:px-20 sm:px-14 px-5 text-gray-700 text-base"
    >
      <img :src="require('@/assets/images/intro.png')" class="lg:mt-0 sm:mt-2 mt-8 object-contain md:object-scale-down" height="500" />
      <h1 class="my-10">Banyan Overview:</h1>
      <p>
        The Banyan Services allow for merchants to provide receipt data related to a customer’s transaction, directly to the financial institution (banks, credit card companies, etc.) without the merchant having to enter into contracts directly with each financial entity for pre-approved use-cases of the data as outlined inthe Merchant Integration Agreement. Banyan—who directly contracts with the respective entities—acts as the middleware by receiving the receipt data from the merchant providing such data through its proprietary API or standard batch process to the financial institution. The financial institution can then execute the use-case such as issuing credit for card linked offers or even displaying the receipt in the banking app.. <br />
         Additionally, certain anonymized information related to transactions and the particular merchants are further extracted for analytics to better understand transaction data and the merchant’s customers to better the Banyan services.
         <br /><br />
        <b>Data Privacy - Banyan operates a fully opt-in first party data consumer network. Merchants are not required to obtain consent from the end user as the Financial Institution is the entity with the consent responsibility. No data is shared without consumer opt-in and merchant opt-in.</b> 
      </p>

      <h1 class="my-10">Participating Entities:</h1>
      <table class="table-fixed bg-gray-100 rounded-md mb-10">
        <thead>
          <tr>
            <th class="w-2/6 px-4 py-2">PARTICIPATING ENTITIES</th>
            <th class="w-2/6 px-4 py-2">DESCRIPTION</th>
            <th class="w-2/6 px-4 py-2">COUNTRIES</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="font-bold text-base px-4 py-2">MERCHANTS</td>
            <td class="text-sm px-4 py-2">Merchants can range from large size entities like the Walmart, to smaller entities. Merchants will be the entities that are responsible for sending data collected from a transaction to Banyan.</td>
            <td class="text-sm px-4 py-2">
              Merchants are primarily located in the U.S. at the moment, but may also have international operations
            </td>
          </tr>
          <tr>
            <td class="font-bold text-base px-4 py-2">FINANCIAL INSTITUTION</td>
            <td class="text-sm px-4 py-2">Banks, credit card companies, or other similar financial institutions that allow for electronic payment to Merchants for merchant products and/or services (can include service providers like Cardlytics).</td>
            <td class="text-sm px-4 py-2">
              Financial institution partners arecurrently both U.S. and global institutions.
            </td>
          </tr>
          <tr>
            <td class="font-bold text-base px-4 py-2">CUSTOMER</td>
            <td class="text-sm px-4 py-2">An individual customer of a participating Merchantthat uses a payment mechanism of a participating financial institution.</td>
            <td class="text-sm px-4 py-2">
              Services should be able to accommodate both U.S. and International customers.
            </td>
          </tr>
          <tr>
            <td class="font-bold text-base px-4 py-2">BANYAN</td>
            <td class="text-sm px-4 py-2">Banyan enters into contracts with both Merchants and Financial Institutions and facilitates the sharingof respective Merchant information as well as runs analytics on de identified information obtained from merchant data</td>
            <td class="text-sm px-4 py-2">USA - Banyan and its data processing is currently performed in the United States only.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="xl:w-1/3 xl:block hidden w-full xl:self-stretch pt-20 px-6 relative"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("common", ["isOffset"]),
  },
  methods: {
    scrollToElement(el) {
      document.querySelector(el).scrollIntoView({
        behavior: 'smooth'
      });
    }
  }
}
</script>